import { createServer } from 'miragejs'
import * as api from './mirageEndpoints'
const requestedLabels = require('../assets/fixtures/requestedLabels-response.json')

export function startMirage() {
  createServer({
    routes() {
      this.get(api.getSavedLabelsUrl, () => {
        return requestedLabels
      })
      this.passthrough('https://login.microsoftonline.com/**')
      this.passthrough('https://graph.microsoft.com/**')
      this.passthrough(process.env.REACT_APP_URL + '/**')
      this.passthrough(process.env.REACT_APP_API_ENDPOINT + '/**')
      this.passthrough(process.env.REACT_APP_AUTHORITY + '/**')
      this.passthrough(`${process.env.REACT_APP_CLIENT_ID}/.default`)
      this.passthrough('https://developer.mozilla.org/*')
      this.passthrough('https://kolumbus.dev.newmarketsdevii.a-kmtkmg.net/')
      this.passthrough('https://kolumbus.prod.newmarketsdevii.a-kmtkmg.net/')
      this.passthrough('https://kolumbus.nonprod.newmarketsdevii.a-kmtkmg.net/')
      this.passthrough('http://localhost:3000/**')
      this.passthrough('blob:http://localhost:3000/**')
      this.passthrough('https://coredata.dev.newmarketsdevii.a-kmtkmg.net/api/download/generatePresignedUrl')
      this.passthrough('https://coredata.dev.newmarketsdevii.a-kmtkmg.net/api/productAttribute/**')
    }
  })
}